module.exports = __webpack_public_path__ + "img/logo.11cb9cf4.png";